import type {HttpClient} from '@sollapay/http-client';
import type {
  AddBuyersToPurchasePayload,
  ApiResponse,
  BuyerDTO,
  BuyerWithDocumentsDTO,
  CreateBuyersPayload,
  RegulatoryReportsDTO,
  UpdateBuyerPayload,
  UpdateRegulatoryReportsPayload
} from '@sollapay/types';

export const buyersApi = {
  fetchBuyers: async (
    client: HttpClient,
    trustAccountId: string
  ): Promise<ApiResponse<BuyerDTO[]>> => {
    return client.get<ApiResponse<BuyerDTO[]>>(`/trust_accounts/${trustAccountId}/buyers`);
  },

  fetchBuyer: async (
    client: HttpClient,
    trustAccountId: string,
    buyerId: string
  ): Promise<ApiResponse<BuyerWithDocumentsDTO>> => {
    return client.get<ApiResponse<BuyerWithDocumentsDTO>>(
      `/trust_accounts/${trustAccountId}/buyers/${buyerId}`
    );
  },

  createBuyers: async (
    client: HttpClient,
    trustAccountId: string,
    payload: CreateBuyersPayload
  ): Promise<ApiResponse<BuyerDTO[]>> => {
    return client.post<ApiResponse<BuyerDTO[]>, CreateBuyersPayload>(
      `/trust_accounts/${trustAccountId}/buyers`,
      payload
    );
  },

  addBuyersToPurchase: async (
    client: HttpClient,
    trustAccountId: string,
    purchaseId: string,
    payload: AddBuyersToPurchasePayload
  ): Promise<ApiResponse<BuyerDTO[]>> => {
    return client.post<ApiResponse<BuyerDTO[]>, AddBuyersToPurchasePayload>(
      `/trust_accounts/${trustAccountId}/purchases/${purchaseId}/buyers`,
      payload
    );
  },

  updateBuyer: async (
    client: HttpClient,
    trustAccountId: string,
    buyerId: string,
    payload: UpdateBuyerPayload
  ): Promise<ApiResponse<BuyerDTO>> => {
    return client.patch<ApiResponse<BuyerDTO>, UpdateBuyerPayload>(
      `/trust_accounts/${trustAccountId}/buyers/${buyerId}`,
      payload
    );
  },

  updatePurchaseRegulatoryReports: async (
    client: HttpClient,
    trustAccountId: string,
    purchaseId: string,
    payload: UpdateRegulatoryReportsPayload
  ): Promise<ApiResponse<{purchaseId: string; regulatoryReports: RegulatoryReportsDTO}>> => {
    return client.patch(
      `/trust_accounts/${trustAccountId}/purchases/${purchaseId}/regulatory-reports`,
      payload
    );
  },

  deleteBuyer: async (
    client: HttpClient,
    trustAccountId: string,
    purchaseId: string,
    buyerId: string
  ): Promise<void> => {
    return client.delete<void>(
      `/trust_accounts/${trustAccountId}/purchases/${purchaseId}/buyers/${buyerId}`
    );
  }
};
